import { generateId } from './timeHelpers';
import { createAddendum } from './addendum';

export function createCarePlanRecord({
  noteContent,
  documentationTime,
  careTime = null,
  careDayOffset = null,
  now = new Date(),
}) {
  const content = noteContent || {};
  const plan = content.care_plan || {};
  return {
    id: generateId(),
    datetime: documentationTime || content.datetime || now.toISOString(),
    care_time: careTime ?? content.care_time ?? null,
    care_day_offset:
      careDayOffset === 0 || careDayOffset === 1
        ? careDayOffset
        : content.care_day_offset ?? null,
    care_plan: {
      nursing_diagnosis: plan.nursing_diagnosis || 'Not documented.',
      goals: plan.goals || 'Not documented.',
      interventions: Array.isArray(plan.interventions) ? [...plan.interventions] : [],
      evaluation: plan.evaluation || 'To be evaluated at next assessment.',
    },
    status: 'active',
    resolved_at: null,
    addenda: [],
  };
}

export function sortCarePlans(carePlans = []) {
  return [...carePlans].sort((a, b) => {
    const aResolved = a.status === 'resolved' ? 1 : 0;
    const bResolved = b.status === 'resolved' ? 1 : 0;
    if (aResolved !== bResolved) return aResolved - bResolved;
    return new Date(b.datetime).getTime() - new Date(a.datetime).getTime();
  });
}

export function attachAddendumToCarePlan(carePlan, addendum) {
  if (!carePlan || !addendum?.addendum_text) return carePlan;
  const existing = Array.isArray(carePlan.addenda) ? carePlan.addenda : [];
  return {
    ...carePlan,
    addenda: [...existing, addendum],
  };
}

export function createCarePlanAddendum({ carePlanId, text, careTime, careDayOffset, now = new Date() }) {
  return createAddendum({
    originalNoteId: carePlanId,
    text,
    careTime,
    careDayOffset,
    now,
  });
}
